<div class="main px-5">
  <form [formGroup]="entidadeForm" id="entidadeForm" #formElement (ngSubmit)="submit()">
    <div class="row mt-4">
      <div class="col-12 mt-3 py-2 px-5 bg-light-color">

        <div class="col-12 d-flex mt-3 justify-content">
          <div class="d-flex col-10">
            <h3 class="fw-bold text-primary-color my-3">{{ inserir ? 'Cadastrar Entidade' : 'Editar Entidade' }}</h3>
          </div>
        </div>

        <section class="row align-items-center">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Dados Básicos</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <app-dados-basicos-form [entidadeForm]="entidadeForm" [entidade]="entidade" [cnpjValido]="cnpjValido"
                [somenteVisualizar]="somenteVisualizar" [nomePagina]="nomePagina">
              </app-dados-basicos-form>
            </div>
          </div>
        </section>

        <ng-container *ngIf="exibirSecaoContatos">
          <section class="row align-items-center">
            <div class="col mt-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="fw-bold text-primary-color">Contatos</p>
                <i class="fi fi-rs-bank"></i>
              </div>
              <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
              <div class="col-12 py-3">
                <ng-container *ngIf="carregandoComplemento; else contatosProntos">
                  <div class="area-interna-carregando">
                    <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                  </div>
                </ng-container>
                <ng-template #contatosProntos>
                  <app-contato-form [entidadeForm]="entidadeForm" [dataSet]="dataSet" [paginaEntidade]="true"
                    [contato]="contato" (contatoEmit)="receberDadosContato($event)"
                    [somenteVisualizar]="somenteVisualizar"></app-contato-form>
                </ng-template>
              </div>
            </div>
          </section>

          <section class="row align-items-center">
            <div class="col mt-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="fw-bold text-primary-color">Outros Contatos</p>
                <i class="fi fi-rs-bank"></i>
              </div>
              <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
              <div class="col-12 py-3">
                <ng-container *ngIf="carregandoComplemento; else outrosContatosProntos">
                  <div class="area-interna-carregando">
                    <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                  </div>
                </ng-container>
                <ng-template #outrosContatosProntos>
                  <app-outros-contatos-list [nomePagina]="nomePagina" [form]="entidadeForm" [data]="entidade"
                    [somenteVisualizar]="somenteVisualizar"></app-outros-contatos-list>
                </ng-template>
              </div>
            </div>
          </section>
        </ng-container>

        <section class="row align-items-center">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Grupos de Correspondência</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <ng-container *ngIf="carregandoComplemento; else gruposProntos">
                <div class="area-interna-carregando">
                  <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                </div>
              </ng-container>
              <ng-template #gruposProntos>
                <app-grupos [nomePagina]="nomePagina" [entidadeForm]="entidadeForm" [data]="entidade"
                  [somenteVisualizar]="somenteVisualizar"></app-grupos>
              </ng-template>
            </div>
          </div>
        </section>

        <section class="row align-items-center">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Documentos</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <ng-container *ngIf="carregandoComplemento; else documentosProntos">
                <div class="area-interna-carregando">
                  <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                </div>
              </ng-container>
              <ng-template #documentosProntos>
                <app-documento-list [nomePagina]="nomePagina" [documentoForm]="entidadeForm" [data]="entidade"
                  [paginaEntidade]="true" [somenteVisualizar]="somenteVisualizar"></app-documento-list>
              </ng-template>
            </div>
          </div>
        </section>

        <section class="row align-items-center" *ngIf="editar">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Vínculos</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <ng-container *ngIf="carregandoComplemento; else vinculosProntos">
                <div class="area-interna-carregando">
                  <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                </div>
              </ng-container>
              <ng-template #vinculosProntos>
                <app-vinculo-tabela [nomePagina]="nomePagina" [entidade]="entidade" [form]="entidadeForm"
                  [somenteVisualizar]="somenteVisualizar"></app-vinculo-tabela>
              </ng-template>
            </div>
          </div>
        </section>

        <section class="row align-items-center" *ngIf="editar && mostrarMovimentacaoSocietaria">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Movimentação Societária</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <ng-container *ngIf="carregandoComplemento; else movimentacaoPronta">
                <div class="area-interna-carregando">
                  <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                </div>
              </ng-container>
              <ng-template #movimentacaoPronta>
                <app-movimentacao-societaria-tabela [nomePagina]="nomePagina" [entidade]="entidade"
                  [nomeEntidade]="entidade" [form]="entidadeForm"
                  (atualizarTabelaMovimentacao)="atualizarDadosMovimentacao($event)"
                  [somenteVisualizar]="somenteVisualizar"></app-movimentacao-societaria-tabela>
              </ng-template>
            </div>
          </div>
        </section>

        <section class="row align-items-center">
          <div class="col mt-3">
            <div class="d-flex align-items-center justify-content-between">
              <p class="fw-bold text-primary-color">Observações</p>
              <i class="fi fi-rs-bank"></i>
            </div>
            <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
            <div class="col-12 py-3">
              <ng-container *ngIf="carregandoComplemento; else observacoesProntas">
                <div class="area-interna-carregando">
                  <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                </div>
              </ng-container>
              <ng-template #observacoesProntas>
                <app-observacoes-form [nomePagina]="nomePagina" [observacoesForm]="entidadeForm" [data]="entidade"
                  [somenteVisualizar]="somenteVisualizar"></app-observacoes-form>
              </ng-template>
            </div>
          </div>
        </section>

        <ng-container *ngIf="editar || visualizar">
          <section class="row align-items-center">
            <div class="col mt-3">
              <div class="d-flex align-items-center justify-content-between">
                <p class="fw-bold text-primary-color">Informativos</p>
                <i class="fi fi-rs-bank"></i>
              </div>
              <nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>

              <div class="col-12 py-3">
                <ng-container *ngIf="carregandoComplemento; else informativosProntos">
                  <div class="area-interna-carregando">
                    <nz-spin nzSimple nzTip="Carregando..."></nz-spin>
                  </div>
                </ng-container>
                <ng-template #informativosProntos>
                <section class="row align-items-center">
                  <div class="col mt-3">

                    <nz-collapse nzAccordion class="rounded-2">
                      <!-- <nz-collapse-panel nzHeader="Vínculos" class="rounded-2">
                        <app-entidade-vinculo-list [entidade]="entidade"></app-entidade-vinculo-list>
                      </nz-collapse-panel> -->

                      <!-- <nz-collapse-panel nzHeader="Movimentação Societária" class="rounded-2">
                        <app-entidade-movimentacao-list [entidade]="entidade"></app-entidade-movimentacao-list>
                      </nz-collapse-panel> -->

                      <nz-collapse-panel nzHeader="Logs de alteração" class="rounded-2">
                        <app-historico-list [entidade]="entidade"></app-historico-list>
                      </nz-collapse-panel>

                      <nz-collapse-panel nzHeader="Árvore Hierárquica" class="rounded-2">
                        <app-arvore-list [entidade]="entidade"></app-arvore-list>
                      </nz-collapse-panel>
                    </nz-collapse>

                  </div>
                </section>
                </ng-template>
              </div>
            </div>
          </section>
        </ng-container>

        <nz-divider></nz-divider>

        <div id="footer-btns-fixed" class="col-12 footer-btns-fixed">
          <div class="row mb-4 p-0">
            <div class="d-flex justify-content-between w-100">
              <div class="col-4">
                <button nz-button nzType="default" nzSize="large"
                  class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
                  Voltar
                  <span class="fs-3 ms-2 mdi--search"></span>
                </button>
              </div>

              <div class="col-4 text-center" *ngIf="nomeFantasiaControl?.value">
                <p class="fs-5 fw-bold">{{ nomeFantasiaControl?.value }}</p>
              </div>

              <div class="col-4 d-flex justify-content-end">
                <ng-template [ngxPermissionsOnly]="[perfilEnum.Administrador, perfilEnum.Validador]">
                  <button nz-button nzType="primary" nzSize="large"
                    class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="submit" form="entidadeForm"
                    *ngIf="!visualizar">
                    Salvar cadastro
                    <span class="fs-3 ms-2 mdi mdi-search"></span>
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </form>
</div>